import {assistSerializedFieldTypeName, assistSerializedTypeName} from '../../types'

export const hiddenTypes = [
  'any',
  'array',
  'block',
  'boolean',
  'crossDatasetReference',
  'date',
  'datetime',
  'document',
  'email',
  'file',
  'globalDocumentReference',
  'image',
  'number',
  'object',
  'reference',
  'span',
  'string',
  'text',
  'url',
  'slug',
  'geopoint',
  'sanity.assetSourceData',
  'sanity.imageAsset',
  'sanity.fileAsset',
  'sanity.imageCrop',
  'sanity.imageHotspot',
  'sanity.imageMetadata',
  'sanity.imageDimensions',
  'sanity.imagePalette',
  'sanity.imagePaletteSwatch',

  assistSerializedTypeName,
  assistSerializedFieldTypeName,
  'sanity-agent.job.document',
]
